// Models
/**
 * Describes errors that caused app initialization to fail
 */ export var FailedReason = /*#__PURE__*/ function(FailedReason) {
    /**
     * Authentication failed
     */ FailedReason["AuthFailed"] = "AuthFailed";
    /**
     * The application timed out
     */ FailedReason["Timeout"] = "Timeout";
    /**
     * The app failed for a different reason
     */ FailedReason["Other"] = "Other";
    return FailedReason;
}({});
/**
 * Describes expected errors that occurred during an otherwise successful app initialization
 */ export var ExpectedFailureReason = /*#__PURE__*/ function(ExpectedFailureReason) {
    /**
     * There was a permission error
     */ ExpectedFailureReason["PermissionError"] = "PermissionError";
    /**
     * The item was not found
     */ ExpectedFailureReason["NotFound"] = "NotFound";
    /**
     * The network is currently throttled
     */ ExpectedFailureReason["Throttling"] = "Throttling";
    /**
     * The application is currently offline
     */ ExpectedFailureReason["Offline"] = "Offline";
    /**
     * The app failed for a different reason
     */ ExpectedFailureReason["Other"] = "Other";
    return ExpectedFailureReason;
}({});
